import {Polyfill} from '@aofl/polyfill-service';
import polyfills from './__config/polyfills';
import {SentryService} from './sentry-service';

window.aofljsConfig = window.aofljsConfig || {};

SentryService.init();

Polyfill.loadAll(polyfills)
  .then(() => {
    import(/* webpackMode: "eager" */'./app');
  });
